<form [id]="formId" [formGroup]="formGroup" (submit)="submit()">
  @let gap = '16px';
  @let col = smallWidth ? { width: 'auto' } : { width: bikes.length === 1 ? 'auto' : 'calc(50% - (' + gap + '/2))' };
  @let cols = smallWidth ? [ col ] : bikes.length === 1 ? [ col ] :  [col, col];

  @if (bikes.length > 0) {
    <kendo-label [text]="'accessoriesSelection.accessoriesForYourBikes' | translate" style="font-weight: bold;"/>
    <app-spacer/>
    <kendo-gridlayout [cols]="cols" [gap]="{ rows: gap, cols: gap }">
      @for (bike of bikes; track $index; let e = $even) {
        <kendo-gridlayout-item [col]="smallWidth ? 1 : (e ? 1 : 2)" [colSpan]="smallWidth ? 1 : (bikes.length === 1 ? 2 : 1)">
          <div class="col">
            <div class="product-container">
              <div class="product-label">{{bike.translations[lang()]}}{{ bike?.height && bike.height > 0? ' (' + (bike.height) + ' cm)' : '' }}</div>
              <kendo-formfield [formGroupName]="'bike-' + bike.id">
                <kendo-dropdownlist
                  [data]="bike.supportedAccessories"
                  size="medium"
                  textField="translations.{{ lang() }}"
                  valueField="bikeType"
                  [defaultItem]="emptyAccessoryModel"
                  formControlName="accessories">
                  <ng-template kendoDropDownListItemTemplate let-dataItem>
                    @if (dataItem.translations.id === -1) {
                      {{dataItem.translations[lang()]}}
                    } @else {
                      <div style="align-items: center;">
                        <strong>{{dataItem.translations[lang()]}}</strong>
                        <small>{{ '(' + (
                          (smallWidth ? 'accessoriesSelection.qty' : 'availability') | translate
                        ) + ': ' + dataItem.availability + ')' }}
                        </small>
                      </div>
                    }
                  </ng-template>
                </kendo-dropdownlist>
              </kendo-formfield>
            </div>
          </div>
        </kendo-gridlayout-item>
      }
    </kendo-gridlayout>
    @if (limitError) {
      <div style="margin: 2rem">
        <kendo-dialog
          (close)="limitError =! limitError"
          [title]="'attention' | translate"
          [minWidth]="250"
          [width]="450">
          <p style="margin: 30px; text-align: center;" class="k-form-field-error">{{ 'accessoriesSelection.limitError' | translate }}</p>
        </kendo-dialog>
      </div>
    }
  }

  @if (bikes.length > 0 && extraAccessories.length > 0) {
    <app-spacer/>
    <hr>
    <app-spacer/>
  }

  @if (extraAccessories.length > 0) {
    @if (bikes.length > 0) {
      <kendo-label [text]="'accessoriesSelection.otherAccessories' | translate" style="font-weight: bold;"/>
      <app-spacer/>
    }

    @let accCol = smallWidth ? { width: 'auto' } : { width: extraAccessories.length === 1 ? 'auto' : 'calc(50% - (' + gap + ' / 2))'};
    @let accCols = smallWidth ? [ accCol ] : (extraAccessories.length === 1 ? [ accCol ] : [accCol, accCol]);
    <kendo-gridlayout [cols]="accCols" [gap]="{ rows: gap, cols: gap }">
      @for (accessory of extraAccessories; track $index; let ev = $even) {
        <kendo-gridlayout-item [col]="smallWidth ? 1 : (ev ? 1 : 2)" [colSpan]="smallWidth ? 1 : (extraAccessories.length === 1 ? 2 : 1)">
          <div class="col">
            <kendo-formfield [formGroupName]="'accessory-' + accessory.bikeType">
              <div class="product-container">
                <div class="product-label">{{accessory.translations[lang()]}}</div>
                <kendo-numerictextbox
                  size="medium"
                  format="##"
                  [inputAttributes]="{inputmode: 'numeric'}"
                  [decimals]="0"
                  [min]="0"
                  [max]="accessory.availability"
                  [autoCorrect]="true"
                  (wheel)="onMouseWheel()"
                  formControlName="quantity">
                </kendo-numerictextbox>
              </div>
            </kendo-formfield>
            <small>{{ 'availability' | translate }}: {{ accessory.availability }}</small>
          </div>
        </kendo-gridlayout-item>
      }
    </kendo-gridlayout>
  }
</form>
